var map = {
	"./tab-1.json": 4697,
	"./tab-2.json": 415,
	"./tab-3.json": 4687,
	"./tab-4-company.json": 6536,
	"./tab-4.json": 2722,
	"./tab-5.json": 6701,
	"./tab-6.json": 3187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9615;